import request from '@/utils/request'
import URL from './urlTranslator'

export function queryTenantMenus(tenantUuid) {
  const params = { tenantUuid }
  return request({
    url: `${URL.sys.queryTenantMenus}`,
    method: 'get',
    params
  })
}

export function queryTenantMenuList(tenantUuid) {
  const params = { tenantUuid }
  return request({
    url: `${URL.sys.queryTenantMenuList}`,
    method: 'get',
    params
  })
}

export function removeTenantMenus(data) {
  return request({
    url: `${URL.sys.removeTenantMenus}`,
    method: 'post',
    data
  })
}

export function loadStatisticsMenus() {
  return request({
    url: `${URL.sys.loadStatisticsMenus}`,
    method: 'get'
  })
}

export function queryByUuid(params) {
  return request({
    url: URL.sys.sysMenu,
    method: 'get',
    params
  })
}
export function queryAllMenus() {
  return request({
    url: URL.sys.queryAllMenus,
    method: 'get'
  })
}

export function save(data) {
  return request({
    url: URL.sys.sysMenu,
    method: 'post',
    data
  })
}

export function updateMenuH5OpenUrl(data) {
  return request({
    url: URL.sys.updateMenuH5OpenUrl,
    method: 'post',
    data
  })
}

export function addTenantMenus(data) {
  return request({
    url: URL.sys.addTenantMenus,
    method: 'post',
    data
  })
}

export function initMenu(data) {
  return request({
    url: URL.sys.initMenu,
    method: 'post',
    data
  })
}

export function sendMenuClickLogBuriedPoints(data) {
  return request({
    url: URL.sys.sendMenuClickLogBuriedPoints,
    method: 'post',
    data
  })
}

